// ArtworkDetail.jsx
import React, { useState } from "react";
import classes from "./artworkDetail.module.css";
import { ARTIST_1, ARTIST_2 } from "../../../utils/images";
import Footer from "../../../components/footer";

const ArtworkDetail = ({ artwork }) => {
  // This would normally come from props or context in a real app
  // Using hardcoded data for demo purposes
  const artworkData = {
    id: 1,
    title: "Lion Spirit",
    artist: "Jayna",
    price: 1600,
    currency: "$",
    description:
      "This captivating acrylic painting, titled \"Lion Spirit Animal,\" is a vibrant and deeply evocative work of art that merges the boundary between realism and abstract. The lion's soft yet piercing gaze draws you in, reflecting wisdom, strength, and an unspoken connection to the viewer's soul. Each brushstroke meticulously crafts the lion's majestic fur, blending hues of gold, amber, and brown, creating a dynamic texture that feels almost tangible. The background is a mesmerizing blend of blues and purples that enhance the spiritual essence of this magnificent creature.",
    medium: "Acrylic Paint",
    collections: ["Animals", "Fantasy"],
    size: "30in (W) X 40in (H)",
    availability: "Available",
    image: ARTIST_2,
    thumbnail: ARTIST_1,
    artistInfo: {
      name: "Jayna",
      location: "Vancouver, Canada",
      bio: "Meet Jayna: Your Go-To Artist for Stunning Visual Creations. Specializing in murals, canvas paintings, portraits, pet portraits, and window painting, her creativity meets personalized service. Her beautiful portfolio is filled with captivating art and murals that adorn businesses and homes throughout Vancouver and the lower mainland of BC.",
      avatar: ARTIST_1,
    },
    relatedArtworks: [
      {
        id: 2,
        title: "Pet Portrait",
        price: 300,
        image: ARTIST_1,
        size: "12in (W) X 12in (H)",
        medium: "Canvas Painting",
        availability: "Sold",
      },
      {
        id: 3,
        title: "Only Human Afterall",
        price: 1200,
        image: ARTIST_1,
        size: "30in (W) X 30in (H)",
        medium: "Canvas Painting",
        availability: "Available",
      },
      {
        id: 4,
        title: "The Matriarchy",
        price: 2500,
        image: ARTIST_1,
        size: "30in (W) X 30in (H)",
        medium: "Canvas Painting",
        availability: "Sold",
      },
    ],
  };

  const [showFullDescription, setShowFullDescription] = useState(false);
  const [showFullBio, setShowFullBio] = useState(false);
  const [selectedImage, setSelectedImage] = useState(artworkData.image);

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  const toggleBio = () => {
    setShowFullBio(!showFullBio);
  };

  return (
    <>
      <div className={classes.container}>
        <div className={classes.artworkDetail}>
          {/* Left column - Images */}
          <div className={classes.imageColumn}>
            <div className={classes.mainImageContainer}>
              <img
                src={selectedImage}
                alt={artworkData.title}
                className={classes.mainImage}
              />
            </div>
            <div className={classes.thumbnailContainer}>
              <div
                className={`${classes.thumbnail} ${
                  selectedImage === artworkData.image
                    ? classes.activeThumbnail
                    : ""
                }`}
                onClick={() => setSelectedImage(artworkData.image)}
              >
                <img src={artworkData.thumbnail} alt="Main view" />
              </div>
              <div
                className={classes.thumbnail}
                onClick={() => setSelectedImage(artworkData.thumbnail)}
              >
                <img src={artworkData.thumbnail} alt="Detail view" />
              </div>
            </div>
          </div>

          {/* Right column - Details */}
          <div className={classes.detailsColumn}>
            <div className={classes.artistTag}>
              <div className={classes.categoryTag}>Canvas Art & Painting</div>
              <div className={classes.createdBy}>
                Created by{" "}
                <a href="#" className={classes.artistLink}>
                  {artworkData.artist}
                </a>
                <img
                  src={artworkData.artistInfo.avatar}
                  alt={artworkData.artistInfo.name}
                  className={classes.artistAvatar}
                />
              </div>
            </div>

            <h1 className={classes.title}>{artworkData.title}</h1>

            <div className={classes.description}>
              {showFullDescription
                ? artworkData.description
                : `${artworkData.description.substring(0, 250)}...`}
              <button
                onClick={toggleDescription}
                className={classes.readMoreBtn}
              >
                {showFullDescription ? "Read Less" : "Read More"}
                <span
                  className={
                    showFullDescription ? classes.arrowUp : classes.arrowDown
                  }
                ></span>
              </button>
            </div>

            <div className={classes.artworkInfo}>
              <div className={classes.infoItem}>
                <span className={classes.infoLabel}>Availability:</span>
                <span className={classes.infoValue}>
                  {artworkData.availability}
                </span>
              </div>
              <div className={classes.infoItem}>
                <span className={classes.infoLabel}>Medium:</span>
                <span className={classes.infoValue}>{artworkData.medium}</span>
              </div>
              <div className={classes.infoItem}>
                <span className={classes.infoLabel}>Collection:</span>
                <span className={classes.infoValue}>
                  {artworkData.collections.join(", ")}
                </span>
              </div>
              <div className={classes.infoItem}>
                <span className={classes.infoLabel}>Size:</span>
                <span className={classes.infoValue}>{artworkData.size}</span>
              </div>
            </div>

            <div className={classes.priceSection}>
              <div className={classes.priceLabel}>Price:</div>
              <div className={classes.price}>
                {artworkData.currency}
                {artworkData.price.toLocaleString()}
              </div>
            </div>

            <div className={classes.actionButtons}>
              <button className={classes.buyNowBtn}>
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M9 11l3 3L21 5"></path>
                </svg>
                Buy Now
              </button>
            </div>

            <div className={classes.returnPolicy}>
              <button className={classes.returnPolicyBtn}>
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="9 10 4 15 9 20"></polyline>
                  <path d="M20 4v7a4 4 0 0 1-4 4H4"></path>
                </svg>
                Return Policy
              </button>
            </div>
          </div>
        </div>

        {/* Artist Information */}
        <div className={classes.artistSection}>
          <h2 className={classes.sectionTitle}>Meet the Artist</h2>
          <div className={classes.artistProfile}>
            <div className={classes.artistImageContainer}>
              <img
                src={artworkData.artistInfo.avatar}
                alt={artworkData.artistInfo.name}
                className={classes.artistImage}
              />
            </div>
            <div className={classes.artistDetails}>
              <h3 className={classes.artistName}>
                {artworkData.artistInfo.name}
              </h3>
              <div className={classes.artistActions}>
                <div className={classes.artistLocation}>
                  <svg
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  {artworkData.artistInfo.location}
                </div>
                <button className={classes.favoriteBtn}>
                  <svg
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                  </svg>
                  Favourite
                </button>
              </div>
              <div className={classes.artistBio}>
                {showFullBio
                  ? artworkData.artistInfo.bio
                  : `${artworkData.artistInfo.bio.substring(0, 150)}...`}
                <button onClick={toggleBio} className={classes.readMoreBtn}>
                  {showFullBio ? "Read Less" : "Read More"}
                  <span
                    className={
                      showFullBio ? classes.arrowUp : classes.arrowDown
                    }
                  ></span>
                </button>
              </div>
              <div className={classes.quoteRequestContainer}>
                <button className={classes.requestQuoteBtn}>
                  <svg
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                  </svg>
                  Request a Quote
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* More Artwork Section */}
        <div className={classes.moreArtworkSection}>
          <h2 className={classes.sectionTitle}>
            More artwork by {artworkData.artist}
          </h2>
          <div className={classes.artworkGrid}>
            {artworkData.relatedArtworks.map((artwork) => (
              <div key={artwork.id} className={classes.relatedArtworkCard}>
                <div className={classes.relatedArtworkImageContainer}>
                  <img
                    src={artwork.image}
                    alt={artwork.title}
                    className={classes.relatedArtworkImage}
                  />
                  {artwork.availability === "Sold" && (
                    <div className={classes.soldOverlay}>
                      <span>Sold</span>
                    </div>
                  )}
                  <button className={classes.heartButton}>
                    <svg
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                    </svg>
                  </button>
                </div>
                <div className={classes.relatedArtworkInfo}>
                  <h3 className={classes.relatedArtworkTitle}>
                    {artwork.title}
                  </h3>
                  <div className={classes.relatedArtworkSize}>
                    {artwork.size}
                  </div>
                  <div className={classes.relatedArtworkCategory}>
                    <span className={classes.categoryBadge}>
                      {artwork.medium}
                    </span>
                  </div>
                  <div className={classes.relatedArtworkPriceAction}>
                    <div className={classes.relatedArtworkPrice}>
                      ${artwork.price}
                    </div>
                    {artwork.availability === "Available" ? (
                      <button className={classes.smallBuyBtn}>
                        <svg
                          viewBox="0 0 24 24"
                          width="16"
                          height="16"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M9 11l3 3L21 5"></path>
                        </svg>
                        Buy Now
                      </button>
                    ) : (
                      <button className={classes.smallSoldBtn}>
                        <svg
                          viewBox="0 0 24 24"
                          width="16"
                          height="16"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="8" y1="12" x2="16" y2="12"></line>
                        </svg>
                        Sold
                      </button>
                    )}
                  </div>
                  <button className={classes.quoteButton}>
                    <svg
                      viewBox="0 0 24 24"
                      width="16"
                      height="16"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                    </svg>
                    Request a Quote
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ArtworkDetail;
